import React from 'react';

import { PermissionEnum } from '@modules/permissions/entity';
import { IRouter } from '@routers/interface';

const routerGiftDistributionHistoryDetail: IRouter = {
  path: '/gifts/gift-distribution-history/info/:id',
  loader: React.lazy(() => import('./index')),
  exact: true,
  name: 'gift-distribution-history-info.router.name', //translate here for breadcrumb and sidebar
  masterLayout: true,
  permissionCode: PermissionEnum.RewardRedemptionsViewDetail,
};

export default routerGiftDistributionHistoryDetail;
